(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (component) => {
    if (component.dataset.testimonialsAutoplayInit === 'true') return;
    component.dataset.testimonialsAutoplayInit = 'true';

    const slider = component.querySelector('.slider');
    if (!slider) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const speed = Math.max(2, Number(slider.dataset.speed || 5)) * 1000;
    if (!autoplay) return;

    let timer = null;
    let isHovering = false;

    const getOffset = () => {
      const slides = slider.querySelectorAll('[id^="Slide-"]');
      if (slides.length < 2) return 0;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    };

    const tick = () => {
      if (prefersReducedMotion.matches) return;
      if (isHovering) return;
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      const offset = getOffset();
      if (offset < 1) return;

      const maxLeft = slider.scrollWidth - slider.clientWidth;
      const nextLeft = slider.scrollLeft + offset;
      const left = nextLeft >= maxLeft - 1 ? 0 : nextLeft;
      slider.scrollTo({ left, behavior: 'smooth' });
    };

    const start = () => {
      if (timer || prefersReducedMotion.matches) return;
      timer = window.setInterval(tick, speed);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    component.addEventListener('mouseenter', () => {
      isHovering = true;
    });
    component.addEventListener('mouseleave', () => {
      isHovering = false;
    });
    component.addEventListener('focusin', () => {
      isHovering = true;
    });
    component.addEventListener('focusout', () => {
      isHovering = false;
    });

    prefersReducedMotion.addEventListener('change', () => {
      stop();
      if (!prefersReducedMotion.matches) start();
    });

    start();
  };

  const init = () => {
    document.querySelectorAll('slider-component[data-testimonials-slider="true"]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
